export const OnboardingSideConstants = [
  {
    title: (
      <>
        Welcome <br /> to CoSupport
      </>
    ),
    description: (
      <>
        We’ll set up your first AI agent in just a few minutes. These quick questions will help us
        match the setup to your team’s needs.
      </>
    ),
  },
  {
    title: <>AI Name</>,
    description: (
      <>
        Pick a name for your AI Agent. This name will be shown to customers when the AI responds, so
        choose something that fits your brand and tone of voice.
      </>
    ),
  },
  {
    title: <>Knowledge Base</>,
    description: (
      <>
        This is where your AI learns. Upload files, add FAQs, or pull content from your site. If you
        use Zendesk or Freshdesk, you can sync help center articles and solved tickets directly.
      </>
    ),
  },
  {
    title: <>Prompt Builder</>,
    description: (
      <>
        Choose what your AI should focus on. Support, sales, or a custom role tailored to your
        business.
      </>
    ),
  },
  {
    title: <>AI Role</>,
    description: (
      <>
        Choose what your AI should focus on. Support, sales, or a custom role tailored to your
        business.
      </>
    ),
  },
  {
    title: <>AI Tone of Voice</>,
    description: (
      <>
        Set the way your AI talks to customers. Choose the channel, style, and level of detail so it
        matches your brand.
      </>
    ),
  },
  {
    title: <>Escalation Workflow</>,
    description: (
      <>
        Tell your AI what to do when it doesn’t know the answer. By default, it escalates to your
        team — but you can also forward to email or set other actions.
      </>
    ),
  },
];
